import { Component, Input } from '@angular/core';

@Component({
    selector: 'service-kpi-card',
    templateUrl: './service-kpi-card.component.html',
    styleUrls: ['./service-kpi-card.component.scss'],
    standalone: false
})
export class ServiceKpiCardComponent {

  @Input() title = '';
  @Input() value: number | string = '';
  @Input() icon = 'insights';
  @Input() loading = false;


  get formattedValue(): string {
    if (typeof this.value === 'number') {
      return this.value.toLocaleString("en-US");
    }

    return this.value;
  }
}
